import React from 'react';
import { connect } from 'react-redux';
import { TutorialApp } from 'mblock-tutorial';
import Emitter from '../../services/emitter';

class TutorialBtn extends React.Component {
    state ={
        visible: false
    };

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.intlr.langKey !== this.props.intlr.langKey) {
            this.refs.tutorial && this.refs.tutorial.forceUpdateApp();
            this.refs.tutorial.refs.sery && this.refs.tutorial.refs.sery.forceUpdateSery();
        }
    }

    handleClick = () => {
        this.setState({
            visible: !this.state.visible
        });
    }

    handleLogLessonClick = (stauts, seryId, lessonId) => {
        Emitter.emit('LogTutorial', stauts, seryId, lessonId);
    }

    render() {
        return (
            <div>
                <TutorialApp
                    ref="tutorial"
                    visible={this.state.visible}
                    onLogLessonClick={this.handleLogLessonClick}
                />
                <section title={this.props.intlr.messages['MENU.TUTORIAL']} className={`header-cell tutorial-btn ${this.state.visible ? 'active' : ''}`} onClick={this.handleClick}>
                    <i className="mblock-icon icon-jiaocheng"></i>
                </section>
            </div>
        );
    }
}

const mapDispatchToProps = ({intlr}) => ({
    intlr
});

export default connect(mapDispatchToProps)(TutorialBtn);